module.exports = __webpack_public_path__ + "img/disabled_bankbook.82df4597.svg";